import React from 'react';
import './menu.css';
import dishBeef from '../../assets/beef_top.png';
import dishTofu from '../../assets/tofu_top.png';
import { LuVegan } from "react-icons/lu";

const Menu = () => {
    return (
        <div className="menu">
            <div className="dishes">
                <img className="dish-beef-top" src={dishBeef} alt="beef dish" />
                <img className="dish-tofu-top" src={dishTofu} alt="tofu dish" />
            </div>
            <div className="description">
                <h1>Choose between</h1>
                <br/>
                <div className="beef-or-tofu">
                    <h2><b>Beef</b></h2>
                    <h2 className="or">or</h2>
                    <h2><b>Tofu</b><LuVegan className="vegan-logo" /></h2>
                </div>
                <br/>
                <h4>Always comes with</h4>
                <p>crisp carrots<br/>traditional danmuji<br/>bright red cabbage<br/>refreshing cucumber<br/>savory white cabbage<br/>signature gochu-don sauce</p>
                <br/>
                <h5>Allergies</h5>
                <p>soy, sesame, gluten</p>
            </div>
        </div>
    );
};

export default Menu;